<template>
  <div class="loginbgBox">
    <div class="app-wrap">
      <div class="app-box" @click="downloadPC" v-if="!$config.isPCapp">
        <i class="iconpcduan iconfont"></i>
        下载中介云PC客户端
      </div>
      <div class="app-box">
        <i class="iconshoujiduan iconfont"></i>
        下载{{ appName || '中介云' }}APP
        <transition name="test" appear>
          <div class="qcode-wrap">
            <!-- <img class="app-logo" :src="appLogo" alt=""> -->
            <vueQr
              :text="downloadLink"
              v-if="downloadLink"
              :logoSrc="appLogo"
              :logoScale="0.3"
              :logoCornerRadius="0"
              :correctLevel="3"
              :size="112"
              :margin="5"
              id=""
            />
            <p class="text-info p-6">扫码下载</p>
            <p class="text-info">{{ appName || '中介云' }}APP</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="logincontent">
      <div class="left-box" v-if="recordShow" @click="recordShow = !recordShow">
        <span>版本记录</span>
      </div>
      <version-record ref="versionRecord" v-else @changeShow="recordShow = !recordShow"></version-record>
      <div class="logo-box">
        <div class="web-name" v-if="origin == 'https://saas.lazhuyun.cn'">
          <img class="logo-name" src="@static/images/login/logo_4.png" />
        </div>
        <div class="web-name" v-else>
          <img class="logo-icon" src="@static/images/login/logo.png" />
          <span class="logo-title">{{ $config.appFullName }}</span>
        </div>
      </div>
      <div class="content-right">
        <p v-if="orgName" class="org-name">{{ orgName }}</p>
        <div class="form-box">
          <div class="form-title" v-if="origin == 'https://saas.lazhuyun.cn'">中介运营管理平台</div>
          <div class="form-title" v-else>{{ $config.appName }}</div>
          <div class="login-tab">
            <span @click="changeTab(1)" class="tab" :class="{ 'sel': loginMode == 1 }">账号登录</span>
            <span @click="changeTab(2)" class="tab" :class="{ 'sel': loginMode == 2 }">验证码登录</span>
          </div>
          <div v-show="loginMode == 1">
            <div class="ivu-input-wrapper">
              <i class="iconfont iconyonghuming"></i>
              <input v-model="formInline.account" placeholder="请输入账号" class="ivu-input" type="text" @keyup.enter="yz" />
            </div>
            <div class="ivu-input-wrapper">
              <i class="iconfont iconmima"></i>
              <input v-model="formInline.password" placeholder="请输入密码" class="ivu-input" :type="isSee ? 'text' : 'password'" @keyup.enter="yz" />
              <img src="@static/images/login/eye.png" class="password-eye" v-if="!isSee" @click="isSee = true" alt />
              <Icon type="ios-eye" v-else @click="isSee = false" class="password-eye" />
            </div>
            <div class="ivu-input-wrapper code-input">
              <i class="iconfont iconyanzhengma"></i>
              <input v-model="formInline.code" placeholder="请输入验证码" class="ivu-input" type="text" @keyup.enter="yz" />
              <img :src="'/system/info/createCode?t=' + imgTime" class="code-img" @click="resetCode()" />
            </div>
          </div>
          <div class="sms-wrap" v-show="loginMode == 2">
            <div class="ivu-input-wrapper">
              <i class="iconfont iconyonghuming"></i>
              <input v-model="formMobile.account" placeholder="请输入您的手机号" class="ivu-input" type="text" @keyup.enter="yz" />
            </div>
            <div class="ivu-input-wrapper">
              <i class="iconfont iconmima"></i>
              <input v-model="formMobile.smsCode" placeholder="请输入手机验证码" class="ivu-input" type="text" @keyup.enter="yz" />
              <span @click="checkCode" class="btn-code" :class="{ active: smsText != '获取验证码' }">{{ smsText }}</span>
            </div>
          </div>
          <div class="bottom-text" v-if="origin != 'https://saas.lazhuyun.cn'">
            <div class="checkBox" @click="active = !active" :class="{ active }">
              <i class="iconfont iconziyuanldpi"></i>
            </div>
            <div>
              登录即表示您已同意
              <span class="cur" @click="jumpPage('/public/agreement.html')">平台服务协议</span>
              <span>及</span>
              <span class="cur" @click="jumpPage('/public/privacy.html')">个人信息保护政策</span>
            </div>
          </div>
          <Button class="login-btn" long type="primary" @click="yz" :loading="loading">登 录</Button>
          <div class="forget-tip" v-if="loginMode == 1">
            <span @click="toShowForgetModal">忘记密码</span>
          </div>
        </div>
        <div class="footer">
          <p>助力保险中介机构数字化升级，依托云计算及大模型等新技术</p>
          <p>提供“安全、稳定、高效”的数字化、信息化、风控管理解决方案</p>
        </div>
      </div>
    </div>
    <!-- 安全验证、绑定手机号 -->
    <Modal v-model="showPhoneValid" class="phone-valid-box" class-name="vertical-center-modal" width="500">
      <div slot="header" style="text-align: center">
        <h1 class="phone-valid-title">安全验证</h1>
        <p class="phone-valid-tip">为保障账户安全,请{{ bindPhoneNumber ? '进行身份验证' : '绑定手机号' }}</p>
      </div>
      <div class="phone-code-container">
        <div class="phone-number" v-if="bindPhoneNumber">登录手机号：{{ bindPhoneNumber }}</div>
        <div class="phone-code-box phone-input" v-else>
          <Icon class="icon-phone" type="ios-phone-portrait" />
          <input type="text" v-model="phoneNumber" maxlength="11" placeholder="请输入您的手机号" />
        </div>
        <div class="phone-code-box">
          <img src="../assets/images/icon/org/safe.png" alt />
          <input type="text" v-model="phoneCode" placeholder="请输入短信验证码" />
          <span @click="getCode" :class="{ active: codeText != '获取验证码' }">{{ codeText }}</span>
        </div>
        <div class="tip" v-if="!bindPhoneNumber">注：绑定的手机号可用于登录系统</div>
      </div>
      <div slot="footer">
        <Button size="large" @click="showPhoneValid = false">取消</Button>
        <Button type="primary" size="large" @click="phoneCodeLogin" :disabled="phoneCode.length == 0">{{ bindPhoneNumber ? '确定' : '绑定并登录' }}</Button>
      </div>
    </Modal>
    <!-- 阅读协议弹窗 -->
    <Modal title="阅读协议" v-model="readProtocol" class="my-modal" width="500" @on-ok="loginMode == 1 ? load() : login()" ok-text="已同意">
      <div class="read-title">
        登录即表示您已同意
        <span class="cur" @click="jumpPage('/public/agreement.html')">平台服务协议</span>及
        <span class="cur" @click="jumpPage('/public/privacy.html')">个人信息保护政策</span>
      </div>
    </Modal>
    <forgetPwdModal ref="forgetPwdModal"></forgetPwdModal>
    <validCodeModal :tranfer="false" class-name="valid-box" ref="validCodeModal" @success="getSmsCode"> </validCodeModal>
  </div>
</template>
<script>
//当前实例组件
import forgetPwdModal from "@/components/commons/login/forgetPwdModal";
import validCodeModal from "@/components/commons/login/validCodeModal";
import versionRecord from './versionRecord.vue';
import vueQr from "vue-qr";
export default {
  components: { forgetPwdModal, validCodeModal, vueQr, versionRecord },
  data: () => ({
    downloadLink: '',//app下载链接
    nameLoading: false,
    readProtocol: false,
    recordShow: true,
    orgIco: '',
    orgName: '',
    active: false,
    codeTimer: null,
    loginMode: '1',//1账号密码登录 2短信验证码登录
    imgTime: new Date().getTime(),
    loading: false,
    formInline: {
      account: '',
      password: '',
      code: ''
    },
    formMobile: {
      account: '',//手机号
      password: '',//非必填
      loginType: 2,
      code: '',
      smsCode: '',//短信验证码
    },
    showPhoneValid: false, //手机验证(绑定手机号)弹窗
    phoneNumber: '', //输入的手机号
    bindPhoneNumber: '', //已绑定的手机号
    phoneCode: '', //验证码
    codeText: '获取验证码',
    smsText: '获取验证码',
    count: 60, //验证码时间倒计时
    timer: '', //验证码时间定时器
    isSee: false, //查看密码
    origin: window.location.origin,
    orgCode: '',//机构code
    appName: '',
    appLogo: '',
  }),
  created() {
    this.getOrgInfo();
  },
  methods: {
    // PC客户端下载
    downloadPC() {
      const link = document.createElement("a"); //创建a标签
      link.download = '中介云PC客户端.exe'; //a标签添加属性
      link.style.display = "none";
      link.href = 'https://file.lazhuyun.cn/upload/dmo/2023/10/27/1698385510126157262.exe';
      document.body.appendChild(link);
      link.click(); //执行下载
      URL.revokeObjectURL(link.href); //释放url
      document.body.removeChild(link); //释放标签
    },
    changeTab(val) {
      this.loginMode = val;
      if (val == 1) {
        this.resetCode()
      }
    },
    checkCode() {
      if (this.smsText != '获取验证码') {
        return;
      }
      if (!this.formMobile.account || !this.$regulars.isPhone(this.formMobile.account)) {
        this.$notice.error("请输入正确的手机号");
        return;
      }
      this.$refs.validCodeModal.open({
        params: {
          mobile: this.formMobile.account,
          loginType: 2
        }
      });
    },
    getSmsCode(code) {
      this.formMobile.code = code;
      this.timerStart1()
    },
    getOrgInfo() {
      let orgCode = this.$route.params.code || this.$route.query.code;
      if (location.host == 'ins-okb.lazhuyun.cn') {
        orgCode = '260580000000800';
      }
      localStorage.orgCode = orgCode || ''
      if (!orgCode) {
        this.nameLoading = true;
        this.downloadLink = this.$config.h5Base + '/m/app';
        return;
      } else {
        this.downloadLink = this.$config.h5Base + `/m/${orgCode}/app`;
      }
      this.$http({
        url: '/buz/organizationBase/queryOrgCode',
        type: 'put',
        data: {
          orgCode: orgCode
        }
      })
        .then(res => {
          this.nameLoading = true;
          this.orgIco = res.data.ico;
          this.orgName = res.data.name;
          this.appLogo = res.data.appLogo;
          this.appName = res.data.appName;
        })
        .catch(() => {
          this.nameLoading = true;
        });
    },
    jumpPage(url) {
      window.open(url, '_blank');
    },
    //显示手机号弹窗
    toShowForgetModal() {
      this.$refs.forgetPwdModal.open();
    },
    // 重置验证码
    resetCode() {
      this.imgTime = new Date().getTime();
    },
    yz() {
      if (this.loginMode == 1) {
        if (this.formInline.account == '') {
          this.$notice.msg('请输入您的账号！');
          return;
        }
        if (this.formInline.password == '') {
          this.$notice.msg('请输入您的密码！');
          return;
        }
        if (this.formInline.code == '') {
          this.$notice.msg('请输入验证码！');
          return;
        }
      } else {
        if (this.formMobile.account == '') {
          this.$notice.msg('请输入手机号！');
          return;
        }
        if (this.formMobile.smsCode == '') {
          this.$notice.msg('请输入验证码！');
          return;
        }
      }

      if (this.origin != 'https://saas.lazhuyun.cn' && !this.active) {
        this.readProtocol = true
        return;
      }
      this.loginMode == 1 ? this.load() : this.login();
    },
    load() {
      this.loading = true;
      this.formInline.loginType = 2; //1 运营   2商户或者业务员
      this.formInline.loginMode = this.loginMode;
      this.$http({
        url: '/system/info/validateCode',
        type: 'post',
        forced: 1,
        data: this.formInline
      })
        .then(res => {
          console.log(res)
          this.loading = false;
          this.phoneCode = '';
          if (res.httpCode == 1) {
            if (res.data.userType == 1) {
              //运营账号
              this.bindPhoneNumber = res.data.mobile;
              this.showPhoneValid = true;
            }
            if (res.data.userType == 2 || res.data.userType == 3) {
              //商户账号
              this.login();
            }
          } else {
            this.resetCode();
            this.loading = false;
            this.$notice.error(res.msg);
            this.active = true
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false;
        });
    },
    timerStart1() {
      let count = 60;
      this.smsText = '重新发送' + '（' + count + 's）';
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        count--;
        this.smsText = '重新发送' + '（' + count + 's）';
        if (count <= 0) {
          window.clearInterval(this.timer);
          this.smsText = '获取验证码';
          return;
        }
      }, 1000);
    },
    timeStop() {
      window.clearInterval(this.timer);
      this.codeText = '获取验证码';
    },
    timerStart() {
      let count = 60;
      this.codeText = '重新发送' + '（' + count + 's）';
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        count--;
        this.codeText = '重新发送' + '（' + count + 's）';
        if (count <= 0) {
          window.clearInterval(this.timer);
          this.codeText = '获取验证码';
          return;
        }
      }, 1000);
    },
    getCode() {
      if (this.codeText != '获取验证码') {
        return;
      }
      if (this.bindPhoneNumber) {
        this.phoneNumber = this.bindPhoneNumber;
      }
      if (!this.bindPhoneNumber || !this.$regulars.isPhone(this.phoneNumber)) {
        this.$notice.error('请输入正确的手机号');
        return;
      }
      this.loading = true;
      let url, params;
      let account = this.formInline.account;
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      this.timerStart();
      if (this.bindPhoneNumber) {
        //已绑定手机号，发送登录验证码
        url = '/system/info/sendLoginCode';
        params = {
          account: account,
          code: this.formInline.code,
          password: this.formInline.password
        };
      } else {
        //未绑定手机号,发送绑定验证码
        url = '/system/info/sendMobileBindSms';
        params = {
          mobile: this.phoneNumber
        };
      }
      this.$http({
        type: 'get',
        url: url,
        data: params
      })
        .then(res => {
          this.loading = false;
          if (res.httpCode == 1) {
            // this.$notice.success('验证码发送成功');
            // this.timerStart();
          }
        })
        .catch(e => {
          this.timeStop()
          this.loading = false;
        });
    },
    phoneCodeLogin() {
      if (this.bindPhoneNumber) {
        //已绑定手机号
        this.phoneNumber = this.bindPhoneNumber;
      }
      let account = this.formInline.account;
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      if (!this.phoneCode) {
        this.$notice.msg('请输入短信验证码');
        return;
      }
      if (this.phoneCode.length != 6) {
        this.$notice.msg('请输入6位短信验证码');
        return;
      }
      this.login();
    },
    login() {
      this.loading = true;
      this.active = true
      let account = this.loginMode == 1 ? this.formInline.account : this.formMobile.account;
      let data = {}
      // 如果是ie转码
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        account = encodeURIComponent(account);
      }
      if (this.loginMode == 1) {
        data = {
          account: account,
          password: this.formInline.password,
          loginType: 2,
          code: this.formInline.code,
          smsCode: this.phoneCode,
          loginMode: this.loginMode,//登录方式
        }
      } else {
        data = {
          ...this.formMobile,
          account: account,
          loginType: 2,
          loginMode: this.loginMode,//登录方式
        }
      }
      this.$http({
        type: 'POST',
        url: `/system/userLogin`,
        query: {
          account: account,
          password: this.formInline.password
        },
        data,
        forced: 1
      })
        .then(data => {
          console.log(data)
          this.loading = false;
          if (data.httpCode == 1) {
            localStorage.setItem('hasLogin', true);
            this.$router.replace('/');
          } else {
            this.$notice.error(data.data || data.msg);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$notice.error('账号或者密码不正确！');
        });
    }
  },
  destroyed() {
    window.clearInterval(this.timer);
    clearInterval(this.codeTimer);
    this.codeTimer = null;
  }
};
</script>
<style lang="scss" scoped>
@import './login.scss';
</style>
<style lang="scss">
.my-modal.login-modal .ivu-modal-body {
  padding-left: 20px;
  padding-right: 20px;
}

.valid-box {
  .ivu-modal-wrap {
    width: 42vw;
    min-width: 600px;
    position: absolute;
    right: 0;
    left: unset;
  }
}

.valid-box {
  .ivu-modal {
    position: absolute;
    top: calc(50vh - 116px) !important;
  }
}
</style>
